import React, {useEffect, useState} from "react";
import {RestaurantDetails} from "./RestaurantDetails";
// import restaurant from "../../Reducers/data/restaurant.json";
// import google from "google";
import getRestaurantMenu from "../../Services/documenu";
import {Link, useHistory, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Menus from "../Menu/Menus";
import {RestaurantAddress} from "./RestaurantAddress";
import {RestaurantEdit} from "../ManageRestaurant/RestaurantEdit";
import {bookmark, getBookmarks, getRestaurant} from "../../Services/RestarantDetailsService";
import AddReview from "../AddReview";
import DetailsList from "../Details/DetailsList";
import axios from "axios";
import {axiosLogin} from "../services/loginService";
import NavigationBar from "../NavigationBar";
const selectRestaurant = (state) => state.restaurant.restaurant;
const selectBookmark = (state) => state.restaurant.bookmark;
export const Restaurant = () => {

    // const uluru = { lat: restaurant.geo.lat, lng: restaurant.geo.lon };
    // const map = new google.maps.Map(document.getElementById("map"), {
    //     zoom: 4,
    //     center: uluru,
    // });
    // const marker = new google.maps.Marker({
    //     position: uluru,
    //     map: map,
    // });
    // const blogger = google.blogger({
    //     version: 'v3',
    //     auth: 'YOUR API KEY'
    // });

    let restaurant = useSelector(selectRestaurant);
    let bookmarks = useSelector(selectBookmark);
    const dispatch = useDispatch();
    const {restaurantId} = useParams();
    const [activePage, setActivePage] = useState("overview");

    //using axios for easy fetching
    // useEffect( () =>{
    //     axios.get('  https://food-mafia-server.herokuapp.com/api/checkLogin').
    //     then(response => {
    //         if(response.data.name){
    //             setUser(response.data.name)
    //         }
    //     });
    // }, []);
    const [userId, setUserId] =  useState("");
    const history = useHistory();
    useEffect(() =>{
        axiosLogin().then(response => {
                setUserId(response.data.userId)
            }
        ).catch((e) => {
        });
    }, [restaurantId])

    useEffect(() => {
        if(!bookmarks)
            setBookmarked(false);
        else setBookmarked(bookmarks.bookmark_state);
    }, []);
    useEffect(() =>{
        axiosLogin().then(response => {
                setUserId(response.data.userId)
            }
        ).catch((e) => {
        },[]);
    })
    useEffect(() => {
        // getRestaurantMenu(dispatch, restaurantId, pageNumber);
        getRestaurant(dispatch, restaurantId)
        getBookmarks(dispatch, userId, restaurantId)
    }, []);
    useEffect(() => {
        // getRestaurantMenu(dispatch, restaurantId, pageNumber);
        getBookmarks(dispatch, userId, restaurantId)
    }, [userId]);
    useEffect(() =>{
        if(!userId || userId === '') return
        getBookmarks(dispatch, userId, restaurantId)
    },[]);

    useEffect(() =>{
        if(bookmarks)
            setBookmarked(bookmarks.bookmark_state)
    },[bookmarks]);

    const [bookmarked, setBookmarked] = useState(false);
    const tabClickHandler = (active) =>{
        setActivePage(active)
    }

    const bookmarkClickHandler = () =>{
        bookmark(userId, restaurantId, !bookmarked).then(r => {
            if(r.modifiedCount && r.modifiedCount  > 0){
                setBookmarked(!bookmarked)
            }
            else{
                if(!userId || userId === '') return
                    getBookmarks(dispatch, userId, restaurantId)
            }
        })
    }

    return (
        <div className="row m-4">
            <div className={"row mb-4 position-sticky"}>
                <NavigationBar />
            </div>
            <div className="row">
                <div className="col-6 btn-light bg-transparent ">
                    <span className="h1">{restaurant.restaurant_name}</span>
                </div>
                <div className="col-2">
                  {/*<span className="badge rounded-pill bg-success">*/}
                  {/*  <span className={restaurant.rating? "": "d-none"}>*/}
                  {/*    <strong >{restaurant.rating}</strong> <i className="fas fa-star"/>*/}
                  {/*  </span>*/}
                  {/*  <strong className={restaurant.rating? "d-none": ""}>No ratings</strong>*/}

                  {/*</span>*/}
                </div>
                <div className="col-4"/>
            </div>

            <div className="row">
                <RestaurantAddress address={restaurant.address} />
                <div className="row">
            <span>
              <strong>Phone:</strong> <a className="text-primary" href={"tel:"+restaurant.restaurant_phone}>{restaurant.restaurant_phone}{" "}</a>
            </span>
                    <span className="breadcrumb-item">
                  <strong>Website: </strong>
                  <a className="text-primary" href={restaurant.restaurant_website}>
                    {restaurant.restaurant_website}
                  </a>
            </span>
                </div>
            </div>

            <div className="row mt-2">

                <div className="col-2">
                    {
                        userId !== "" && <button type="button" onClick={bookmarkClickHandler}
                               className={"btn btn-outline-danger rounded-3 "
                               + (bookmarked ? " btn-outline-danger ":' btn-outline-info ')}><i
                            className="far fa-bookmark"/>  {(bookmarked ? "Un-Bookmark":'Bookmark')}
                        </button>
                    }
                    {
                        userId === "" && <Link to="/login">
                            <button type="button" onClick={bookmarkClickHandler}
                                    className={"btn btn-outline-danger rounded-3 "
                                    + (bookmarked ? " btn-outline-danger ":' btn-outline-info ')}><i
                                className="far fa-bookmark"/>  {(bookmarked ? "Un-Bookmark":'Bookmark')}
                            </button>
                        </Link>
                    }

                </div>
                <div className="col-10"/>
            </div>

            <div className="row mt-4 mb-4">
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <div className="container-fluid">
                        {/*<a className="navbar-brand" href="#">Details</a>*/}
                        {/*<button className="navbar-toggler" type="button" data-bs-toggle="collapse"*/}
                        {/*        data-bs-target="#navbarColor03"*/}
                        {/*        aria-controls="navbarColor03" aria-expanded="false" aria-label="Toggle navigation">*/}
                        {/*    <span className="navbar-toggler-icon"/>*/}
                        {/*</button>*/}

                        <div className="collapse navbar-collapse" id="navbarColor03">
                            <ul className="navbar-nav me-auto">
                                <li className={"nav-link"}>
                                    <a className={(activePage ==='overview'? ' active text-primary ':'')}
                                       onClick={()=>tabClickHandler('overview')}>Overview
                                    </a>
                                </li>
                                <li className={"nav-link "+ (activePage ==='review'? 'active':'')}>
                                    <a className={(activePage ==='review'? ' active text-primary ':'')} onClick={()=>tabClickHandler('review')}>
                                        Reviews
                                    </a>
                                </li>
                                <li className={"nav-link "+ (activePage ==='photos'? 'active':'')}>
                                    <a className={(activePage ==='photos'? ' active text-primary ':'')} onClick={()=>tabClickHandler('photos')}>
                                        Photos
                                    </a>
                                </li>
                            </ul>

                        </div>
                    </div>
                </nav>
            </div>

            <div className={activePage ==='overview'? '':'d-none'}>
                <RestaurantDetails restaurant={restaurant}/>
                <div className="row">
                    <Menus menus={restaurant.menus}/>
                </div>
            </div>
            <div className={activePage ==='review'? '':'d-none'}>
                <AddReview hotelId={restaurantId}/>
                <DetailsList hotelId={restaurantId}/>

            </div>
            <div className={activePage ==='photos'? '':'d-none'}>
                photos
            </div>

            {/*<RestaurantEdit restaurantId = {restaurant.restaurantId} />*/}

        </div>

    );
};
